(function(){
  var HEX={"rosu":"#C0392B","rosie":"#C0392B","rosii":"#C0392B","roz":"#E48FB6","roz pudrat":"#E9C7D3","auriu":"#C9A85F","aurie":"#C9A85F","gold":"#C9A85F","maro":"#7A4A2B","brown":"#7A4A2B","burgundy":"#6D1F2C","verde":"#1F4A36","verde inchis":"#163527","alb":"#EFE7D6","albe":"#EFE7D6","white":"#EFE7D6","ivoar":"#F2EAD8","argintiu":"#BFC4C7","argintie":"#BFC4C7","silver":"#BFC4C7","albastru":"#3A6EA5","bleu":"#8FB4D6","bleumarin":"#22304A","negru":"#23231F","sampanie":"#E7D9B0","champagne":"#E7D9B0","bej":"#D9C7A8","gri":"#9AA0A0","crem":"#EDE3CF","portocaliu":"#D98032","galben":"#E7C15A","mov":"#7A5A9E","lila":"#B39DDB","rose":"#E6B5A6","turcoaz":"#2FA5A0","fucsia":"#C0397F","cupru":"#B87333","transparent":"#E4E9EB","natur":"#C9B48F","ivory":"#F2EAD8"};
  function norm(s){ return (s||"").trim().toLowerCase().replace(/[ăâ]/g,"a").replace(/[șş]/g,"s").replace(/[țţ]/g,"t").replace(/î/g,"i"); }
  /* inserează numărul de bucăți în titlu: „Set Globuri…" -> „Set 6 Globuri…" (fără culoare) */
  function withCount(base,n){ if(!n) return base; if(/^Set\s+\d/.test(base)) return base; return base.replace(/^Set\s+/,"Set "+n+" "); }
  /* true dacă șirul HTML conține text vizibil (nu doar etichete goale) */
  function hasTxt(s){ return !!(s && String(s).replace(/<[^>]*>/g,"").replace(/&nbsp;/g," ").trim()); }
  function hexFor(name){
    var k=norm(name); if(!k) return null;
    if(HEX[k]) return HEX[k];
    var parts=k.split(/[\/,]+/).map(function(x){return x.trim();}).filter(Boolean);
    var cols=parts.map(function(p){return HEX[p];}).filter(Boolean);
    if(cols.length>=2) return "linear-gradient(90deg,"+cols.join(",")+")";
    if(cols.length===1) return cols[0];
    return null;
  }
  function init(root){
    var main=root.querySelector(".amcp-mainimg");
    root.querySelectorAll(".amcp-thumb").forEach(function(t){
      t.addEventListener("click",function(){
        var full=t.getAttribute("data-full");
        if(main&&full){ main.setAttribute("src",full); main.removeAttribute("srcset"); }
        root.querySelectorAll(".amcp-thumb").forEach(function(x){x.setAttribute("aria-pressed","false");});
        t.setAttribute("aria-pressed","true");
      });
    });
    var qty=1, qEl=root.querySelector(".amcp-qtyval"), qIn=root.querySelector(".amcp-qty");
    var qm=root.querySelector(".amcp-minus"), qp=root.querySelector(".amcp-plus");
    /* cantitatea nu poate depăși stocul variantei selectate; la maxim „+" devine inactiv (gri) */
    function curMax(){ var v=findVariant(); return (v && typeof v.max==="number") ? v.max : Infinity; }
    function syncQty(){
      var mx=curMax(); if(qty>mx) qty=Math.max(1,mx);
      if(qEl)qEl.textContent=qty; if(qIn)qIn.value=qty;
      /* stocul ajunge și la coș (amc-cart-drawer.js scade ce e deja în coș) */
      if(vid) vid.setAttribute("data-max", isFinite(mx) ? String(mx) : "");
      if(qp) qp.disabled = isFinite(mx) && mx>0 && qty>=mx;
    }
    if(qm) qm.addEventListener("click",function(){ qty=Math.max(1,qty-1); syncQty(); });
    if(qp) qp.addEventListener("click",function(){ qty=qty+1; syncQty(); });
    var el=root.querySelector(".amcp-data"), variants=[];
    try{ variants=JSON.parse(el.textContent); }catch(e){}
    var vid=root.querySelector(".amcp-vid"), priceEl=root.querySelector(".amcp-price"),
        wasEl=root.querySelector(".amcp-was"), offEl=root.querySelector(".amcp-off"), stockEl=root.querySelector(".amcp-stock"),
        dotEl=root.querySelector(".amcp-dot"), addBtn=root.querySelector(".amcp-add"),
        delivEl=root.querySelector(".amcp-deliv");
    var descWrap=root.querySelector(".amcp-descwrap"), descBody=root.querySelector(".pdp-desc"),
        descFb=root.querySelector(".amcp-descfb"), fallbackDesc=descFb?descFb.innerHTML:"";
    /* transformă rândul de culoare în buline + adaugă numele culorii selectate */
    root.querySelectorAll(".opt-row").forEach(function(row){
      var lab=row.querySelector(".opt-label span");
      var nm=(lab?lab.textContent:"").trim().toLowerCase();
      if(nm==="culoare"||nm==="color"){
        row.classList.add("is-color");
        var sn=document.createElement("span"); sn.className="opt-selname";
        if(lab&&lab.parentNode) lab.parentNode.appendChild(sn);
        row.querySelectorAll(".pill").forEach(function(p){
          p.classList.add("pill-sw");
          var val=p.getAttribute("data-val"), hx=hexFor(val);
          if(hx) p.style.background=hx;
          p.setAttribute("title",val); p.setAttribute("aria-label",val);
        });
      }
    });
    var rows=[].slice.call(root.querySelectorAll(".opt-row"));
    /* se taie DOAR rândul de Dimensiune (modelul/culoarea rămân mereu libere) */
    var sizeRow=rows.map(function(row){ var l=row.querySelector(".opt-label span"); var n=norm(l?l.textContent:""); return n==="dimensiune"||n==="marime"||n==="size"; });
    function selectedVals(){
      return rows.map(function(row){ var b=row.querySelector('.pill[aria-pressed="true"]'); return b?b.getAttribute("data-val"):null; });
    }
    function exactVariant(sel){
      return variants.find(function(v){
        return v.options.length===sel.length && v.options.every(function(o,i){return o===sel[i];});
      });
    }
    function findVariant(){ var v=exactVariant(selectedVals()); return v||variants[0]; }
    function setSelection(opts){
      rows.forEach(function(row,i){
        row.querySelectorAll(".pill").forEach(function(p){
          p.setAttribute("aria-pressed", p.getAttribute("data-val")===opts[i] ? "true":"false");
        });
      });
    }
    /* marchează combinațiile care NU există (estompat + tăiat) în funcție de selecția curentă */
    function refreshAvail(){
      var sel=selectedVals();
      rows.forEach(function(row,ri){
        if(!sizeRow[ri]){ row.querySelectorAll(".pill").forEach(function(p){ p.classList.remove("is-unavail"); }); return; }
        row.querySelectorAll(".pill").forEach(function(p){
          var val=p.getAttribute("data-val");
          var exists=variants.some(function(v){
            if(v.options[ri]!==val) return false;
            for(var k=0;k<rows.length;k++){ if(k!==ri && v.options[k]!==sel[k]) return false; }
            return true;
          });
          p.classList.toggle("is-unavail", !exists);
        });
      });
    }
    /* după un click: dacă combinația nu există, păstrează valoarea apăsată și ajustează celelalte axe */
    function reconcile(clickedRow){
      var sel=selectedVals();
      if(!exactVariant(sel)){
        var ri=rows.indexOf(clickedRow);
        var cb=clickedRow.querySelector('.pill[aria-pressed="true"]');
        var cvv=cb?cb.getAttribute("data-val"):null;
        var cand=variants.find(function(v){ return v.options[ri]===cvv && v.avail; })
              || variants.find(function(v){ return v.options[ri]===cvv; });
        if(cand) setSelection(cand.options);
      }
      refreshAvail();
      update();
    }
    function update(){
      var v=findVariant();
      if(!v) return;
      if(vid) vid.value=v.id;
      if(priceEl) priceEl.textContent=v.pf;
      if(wasEl){ if(v.compare&&v.compare>v.price){ wasEl.textContent=v.cpf; wasEl.style.display=""; } else { wasEl.style.display="none"; } }
      if(offEl){ var on=v.compare&&v.compare>v.price; offEl.hidden=!on; if(on) offEl.textContent="−"+Math.round((v.compare-v.price)*100/v.compare)+"%"; }
      if(stockEl) stockEl.textContent = v.avail ? "În stoc, gata de livrare" : "Stoc epuizat";
      if(dotEl) dotEl.style.background = v.avail ? "" : "#6D1F2C";
      if(addBtn){ addBtn.disabled=!v.avail; addBtn.textContent = v.avail ? "Adaugă în coș" : "Stoc epuizat"; }
      /* estimarea de livrare apare doar la variantele în stoc */
      if(delivEl) delivEl.style.display = v.avail ? "" : "none";
      var titleEl=root.querySelector(".amcp-title");
      if(titleEl){ var tb=titleEl.getAttribute("data-base")||titleEl.textContent; titleEl.textContent=withCount(tb, v.b); }
      if(descWrap&&descBody){ var dh=hasTxt(v.d)?v.d:fallbackDesc; if(hasTxt(dh)){ descBody.innerHTML=dh; descWrap.hidden=false; } else { descWrap.hidden=true; } }
      if(v.img && main){ main.setAttribute("src",v.img); main.removeAttribute("srcset");
        root.querySelectorAll(".amcp-thumb").forEach(function(x){x.setAttribute("aria-pressed","false");}); }
      root.querySelectorAll(".opt-row.is-color").forEach(function(row){
        var b=row.querySelector('.pill[aria-pressed="true"]'), sn=row.querySelector(".opt-selname");
        if(b&&sn) sn.textContent=b.getAttribute("data-val");
      });
      syncQty();
    }
    root.querySelectorAll(".pills .pill").forEach(function(p){
      p.addEventListener("click",function(){
        var row=p.closest(".opt-row");
        var changed=p.getAttribute("aria-pressed")!=="true";
        row.querySelectorAll(".pill").forEach(function(x){x.setAttribute("aria-pressed","false");});
        p.setAttribute("aria-pressed","true");
        /* altă variantă -> cantitatea pornește din nou de la 1 */
        if(changed) qty=1;
        reconcile(row);
      });
    });
    var buyNow=root.querySelector(".amcp-buynow");
    if(buyNow) buyNow.addEventListener("click",function(){
      var v=findVariant(); if(!v||!v.avail) return;
      fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:v.id,quantity:qty}]})})
        .then(function(){ window.location.href="/checkout"; })
        .catch(function(){ window.location.href="/cart"; });
    });
    var etaEl=root.querySelector(".amcp-deliv-eta");
    if(etaEl){
      var ZILE=["duminică","luni","marți","miercuri","joi","vineri","sâmbătă"];
      var LUNI=["ian.","feb.","mar.","apr.","mai","iun.","iul.","aug.","sep.","oct.","nov.","dec."];
      function addD(d,n){ var x=new Date(d); x.setDate(x.getDate()+n); return x; }
      function skipSun(d){ return d.getDay()===0 ? addD(d,1) : d; }
      var e=skipSun(addD(new Date(),1)), l=skipSun(addD(new Date(),3));
      var t = e.getMonth()===l.getMonth()
        ? "Comanda ta poate ajunge "+ZILE[e.getDay()]+"–"+ZILE[l.getDay()]+", "+e.getDate()+"–"+l.getDate()+" "+LUNI[l.getMonth()]
        : "Comanda ta poate ajunge "+ZILE[e.getDay()]+" "+e.getDate()+" "+LUNI[e.getMonth()]+" – "+ZILE[l.getDay()]+" "+l.getDate()+" "+LUNI[l.getMonth()];
      etaEl.textContent=t;
    }
    syncQty(); refreshAvail(); update();
  }
  function boot(){ document.querySelectorAll(".amcp").forEach(init); }
  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded",boot); } else { boot(); }
})();
